module.exports = __webpack_public_path__ + "img/meishi.701c8a3b.png";